import React from 'react';

const logoSrc = `${process.env.PUBLIC_URL || ''}/sustainability-hub-logo.png`;

const AppLogo = ({ className = 'h-8 w-8 object-contain' }) => (
  <img src={logoSrc} alt="SustainabilityHub" className={className} />
);

export default AppLogo;
